module.exports = __webpack_public_path__ + "static/media/fill_arrow_up.a5b26e06.svg";